import React, { useContext } from "react";
import {
  Wrapper,
  Container,
  Row,
  Col,
  Image,
  Content,
  ContentWrapper,
} from "./style";
import BrowseButton from "../Commons/BrowseButton/index";
import { ThemeContext } from "../../ThemedContext/Provider";
import Title from "../Commons/Title";

const image1 = "../../../assets/images/td7.png";
const image2 = "../../../assets/images/td8.png";
const image3 = "../../../assets/images/td9.png";

const contents = [
  { image: image1, description: "51 Tracks 8M+ Views", name: "Auguste Rodin" },
  { image: image2, description: "51 Tracks 8M+ Views", name: "Henry Moore" },
  { image: image3, description: "51 Tracks 8M+ Views", name: "Marc Chagall" },
];

const FeatureArtists = () => {
  const { theme } = useContext(ThemeContext);
  return (
    <Wrapper>
      <Title title='FEATURED ARTISTS' />
      <Container>
        {contents.map((content, i) => (
          <Row themed={theme} key={i}>
            <Col>
              <Image>
                <img src={content.image} alt='artist' />
              </Image>
            </Col>
            <Col>
              <ContentWrapper>
                <Content>
                  <div className='content-menu'>
                    <h3>{content.name}</h3>
                  </div>
                  <p>{content.description}</p>
                  <BrowseButton padding='100px' title="Info..."/>
                </Content>
              </ContentWrapper>
            </Col>
          </Row>
        ))}
      </Container>
    </Wrapper>
  );
};

export default FeatureArtists;
